import { ICompanyCreate } from 'src/interfaces';
import { AxiosError } from 'axios';
import http from './http';

class CompanyService {
  static getCompanies() {
    return http.get('/company');
  }

  static getCompaniesByUserID(userId: string) {
    return http.get(`/users/companies-by-id/${userId}`);
  }

  static getWorkflow() {
    return http.get('/users/workflow');
  }

  static getWorkflowById(id: string) {
    return http.get(`/users/workflow/${id}`);
  }

  static deleteCompanyIdConfig(value: string): Promise<void> {
    return http.delete(`/company/${value}`);
  }

  static createCompany(values: ICompanyCreate): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      http
        .post('/company', values)
        .then(() => {
          resolve();
        })
        .catch((error: AxiosError) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          }
        });
    });
  }

  static updateUser(values: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      http
        .put('/users/update', values)
        .then(() => {
          resolve();
        })
        .catch((error: AxiosError) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          }
        });
    });
  }

  static updateUserSupport(values: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      http
        .put('/users/updateUserWithApplication', values)
        .then(() => {
          resolve();
        })
        .catch((error: AxiosError) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          }
        });
    });
  }

  static promoteUser(values: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      http
        .post('/users/promote', values)
        .then(() => {
          resolve();
        })
        .catch((error: AxiosError) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          }
        });
    });
  }

  static promoteUserSupport(values: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      http
        .post('/users/promoteToSupportAdmin', values)
        .then(() => {
          resolve();
        })
        .catch((error: AxiosError) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          }
        });
    });
  }

  static updateSubModuleEmail(values: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      http
        .post('/users/submodule/update', values)
        .then(() => {
          resolve();
        })
        .catch((error: AxiosError) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          }
        });
    });
  }

  static updateModuleEmail(values: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      http
        .post('/users/module/update', values)
        .then(() => {
          resolve();
        })
        .catch((error: AxiosError) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          }
        });
    });
  }
}
export default CompanyService;
